export const PERSONALIZATION_WIDGET = 'personalizationWidget';
export const ENVIRONMENT = 'environment';
